module.exports = __webpack_public_path__ + "img/61.c4d9fffd.png";